import "./gallery-carousel.css";

const GalleryCarousel = ({ imagesDB }) =>  (
    <>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
            <div className="carousel-inner">
                
                {(imagesDB && imagesDB.length !== 0) &&
                    imagesDB.map((image, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                            <img src={image.src} className="d-block w-100" alt="Texas Software Engineer in Austin, Dallas, and Houston" id="presentative-image" />
                        </div>
                    ))
                }
                
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    </>
)

export default GalleryCarousel;